module.exports = __webpack_public_path__ + "static/media/bootcamper menu.6aabcbbb.png";